import { IDO_PRINT_LIST_VIEW_MODE_LARGE } from 'src/stores/idoPrintList/localStorageKeys';

import { GenericActivityListPagination } from 'src/models/genericActivityList';
import { IdoPrintListItem } from 'src/models/idoPrint';

export interface IdoPrintListEntry {
	loading: boolean;
	rows: Array<IdoPrintListItem>;
	totalCount: number;
}

interface IdoPrintListStateInterface {
	listViewModeLarge: boolean;
	pagination: Record<string, GenericActivityListPagination>;
	printListsByKey: Record<string, IdoPrintListEntry>;
	printSearchTermByKey: Record<string, string>;
	printingDocumentIds: Array<string>;
}

function state(): IdoPrintListStateInterface {
	return {
		listViewModeLarge:
			localStorage.getItem(IDO_PRINT_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(localStorage.getItem(IDO_PRINT_LIST_VIEW_MODE_LARGE) as 'false' | 'true')
				: true,
		pagination: {},
		printListsByKey: {},
		printSearchTermByKey: {},
		printingDocumentIds: [],
	};
}

export default state;
